import { ContainerInterno, ContainerModal } from '../../styles';
import { CustomInput } from '../../../../components/CustomInput';
import { CustomSelectPicker } from '../../../../components/CustomSelectPicker';
import { useCustomTheme } from '../../../../hooks/useCustomTheme';

const data = [
    { value: '1', label: 'Percentual' },
    { value: '2', label: 'Valor' },
];

const DadosCupom = ({
    codigoPromo,
    setCodigoPromo,
    descricao,
    setDescricao,
    setTipoDesconto,
    cupom,
    valor,
    setValor,
    utilizacaoMax,
    setUtilizacaoMax,
    utilizacaoMaxCliente,
    setUtilizacaoMaxCliente,
    valorMinCompra,
    setValorMinCompra,
    dataInicio,
    setDataInicio,
    dataFim,
    setDataFim,
    dataAtivo,
    setAtivo
}) => {
    const { theme } = useCustomTheme();

    const MandatoryTag = () => <span style={{ color: '#f00' }}>*</span>;

    return (
        <ContainerModal>
            <ContainerInterno>
                <label htmlFor="codigo">
                    <b style={{ color: theme.colors.textSecondary }}>
                        Código Promocional <MandatoryTag />
                    </b>
                </label>
                <CustomInput
                    type="text"
                    value={codigoPromo}
                    onChange={setCodigoPromo}
                />
            </ContainerInterno>
            <ContainerInterno>
                <label htmlFor="descricao">
                    <b style={{ color: theme.colors.textSecondary }}>
                        Descrição <MandatoryTag />
                    </b>
                </label>
                <CustomInput type="text" value={descricao} onChange={setDescricao} />
            </ContainerInterno>
            <ContainerInterno>
                <label htmlFor="tipoDesconto">
                    <b style={{ color: theme.colors.textSecondary }}>
                        Tipo de Desconto
                    </b>
                </label>
                <CustomSelectPicker
                    data={data}
                    style={{ width: 224 }}
                    onChange={setTipoDesconto}
                    defaultValue={
                        cupom?.TipoDesconto === 2 ? data[1].value : data[0].value
                    }
                    searchable={false}
                />
            </ContainerInterno>
            <ContainerInterno>
                <label htmlFor="valor">
                    <b style={{ color: theme.colors.textSecondary }}>
                        Valor <MandatoryTag />
                    </b>
                </label>
                <CustomInput type="number" value={valor} onChange={setValor} />
            </ContainerInterno>
            <ContainerInterno>
                <label htmlFor="utilizacaoMax">
                    <b style={{ color: theme.colors.textSecondary }}>
                        Utilização Máxima <MandatoryTag />
                    </b>
                </label>
                <CustomInput
                    type="number"
                    value={utilizacaoMax}
                    min={0}
                    onChange={setUtilizacaoMax}
                />
            </ContainerInterno>
            <ContainerInterno>
                <label htmlFor="utilizacaoMax">
                    <b style={{ color: theme.colors.textSecondary }}>
                        Utilização Máxima Por Cliente <MandatoryTag />
                    </b>
                </label>
                <CustomInput
                    type="number"
                    min={0}
                    value={utilizacaoMaxCliente}
                    onChange={setUtilizacaoMaxCliente}
                />
            </ContainerInterno>
            <ContainerInterno>
                <label htmlFor="valorminimo">
                    <b style={{ color: theme.colors.textSecondary }}>
                        Valor Mínimo da Compra
                    </b>
                </label>
                <CustomInput
                    type="number"
                    min={0}
                    value={valorMinCompra}
                    onChange={setValorMinCompra}
                />
            </ContainerInterno>
            <ContainerInterno>
                <label htmlFor="dataInicio">
                    <b style={{ color: theme.colors.textSecondary }}>
                        Data Inicial <MandatoryTag />
                    </b>
                </label>
                <CustomInput
                    type="date"
                    value={dataInicio}
                    onChange={setDataInicio}
                />
            </ContainerInterno>
            <ContainerInterno>
                <label htmlFor="dataFim">
                    <b style={{ color: theme.colors.textSecondary }}>
                        Data Fim <MandatoryTag />
                    </b>
                </label>
                <CustomInput type="date" value={dataFim} onChange={setDataFim} />
            </ContainerInterno>

            {cupom && (
                <ContainerInterno>
                    <label htmlFor="status">
                        <b style={{ color: theme.colors.textSecondary }}>Ativo</b>
                    </label>

                    <CustomSelectPicker
                        data={dataAtivo}
                        style={{ width: 224 }}
                        onChange={setAtivo}
                        defaultValue={
                            cupom.Ativo ? dataAtivo[1].value : dataAtivo[0].value
                        }
                    />
                </ContainerInterno>
            )}
        </ContainerModal>
    )
}

export default DadosCupom;